import {
  UtimacoPacketSwitchState,
  UtimacoPacketSwitchActionTypes,
  GET_UTIMACO_PACKET_SWITCH_LIST,
  GET_UTIMACO_PACKET_SWITCH_LIST_FULFILLED,
  GET_UTIMACO_PACKET_SWITCH_PENDING,
  GET_UTIMACO_PACKET_SWITCH_FULFILLED,
  SELECT_UTIMACO_PACKET_SWITCH,
  CREATE_UTIMACO_PACKET_SWITCH_PENDING,
  CREATE_UTIMACO_PACKET_SWITCH_FULFILLED,
  DELETE_UTIMACO_PACKET_SWITCH_FULFILLED,
  SET_UTIMACO_PACKET_SWITCH_LOADING,
} from './utimacoPacketSwitch.types';

export const initialState: UtimacoPacketSwitchState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function utimacoPacketSwitchReducer(
  state = initialState,
  action: UtimacoPacketSwitchActionTypes,
): UtimacoPacketSwitchState {
  switch (action.type) {
    case GET_UTIMACO_PACKET_SWITCH_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_UTIMACO_PACKET_SWITCH_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_UTIMACO_PACKET_SWITCH_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_UTIMACO_PACKET_SWITCH_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_UTIMACO_PACKET_SWITCH:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_UTIMACO_PACKET_SWITCH_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_UTIMACO_PACKET_SWITCH_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_UTIMACO_PACKET_SWITCH_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_UTIMACO_PACKET_SWITCH_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
